var _defs, _style, _image, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPatrickmSmooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199 145",
    width: 199,
    height: 145,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_patrickm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 199,
    height: 146,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMcAAACSAQMAAADLiEzBAAAAAXNSR0IB2cksfwAAAANQTFRFAP+je4Ey+gAAAAF0Uk5TAEDm2GYAAAAkSURBVHic7cmhAQAADAKg+f/Tu8BugEquiTHGGGOMMcYYMz0PUO4Ak7O6IN0AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00ffa3 } \n\t")), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 199,
    height: 146,
    id: "Calque 1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMcAAACSAQMAAADLiEzBAAAAAXNSR0IB2cksfwAAAANQTFRFAP+je4Ey+gAAAAF0Uk5TAEDm2GYAAAAkSURBVHic7cmhAQAADAKg+f/Tu8BugEquiTHGGGOMMcYYMz0PUO4Ak7O6IN0AAAAASUVORK5CYII="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Calque 1 copy",
    className: "s0",
    d: "M 64.9 35.6 L 11.3 81.5 L 0 67.8 L 52.1 21.9 L 64.9 35.6 Z M 134.7 7.3 L 79.2 145.3 L 61.4 138.5 L 117.6 0.2 L 134.7 7.3 Z M 198.8 77.7 L 145.2 123.6 L 133.9 109.9 L 187.2 63.5 L 198.8 77.7 Z M 198.8 77.6 L 183.965 89.965 L 137.5 33.7 L 151.7 20.7 L 198.8 77.6 Z M 61.2 112 L 46.8 124.7 L -0.1 68 L 14.435 55.771 L 61.2 112 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPatrickmSmooth);
export default __webpack_public_path__ + "static/media/logo_patrickm_smooth.d5c23c4b08bb7b35f6fdea855e5f2da3.svg";
export { ForwardRef as ReactComponent };